import { type FunctionComponent } from 'react';
import * as React from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type ModalBodyProps = {
    className?: string;
    children?: React.ReactNode;
    topSpacing?: 'small' | 'medium' | 'large';
    horizontalPadding?: 'mediumPadding' | 'noPadding';
};

export const ModalBody: FunctionComponent<ModalBodyProps> = props => {
    const { className, children, topSpacing = 'large', horizontalPadding } = props;

    return (
        <div
            className={classnames(styles.modalBody, styles[topSpacing], className, {
                [styles.mediumPadding]: horizontalPadding === 'mediumPadding',
                [styles.noPadding]: horizontalPadding === 'noPadding',
            })}
            data-tn="modal-body"
        >
            {children}
        </div>
    );
};
